import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import { Accordion, Card, AccordionContext, useAccordionToggle } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
import { getLink } from "../dataProvider/links.js"
import { HashLink } from 'react-router-hash-link';
import secureMethod from "../img/v1/payment/secureMethod.png"

import LogoV2 from "../img/v2/logo.png"
import secureMethod2 from "../img/v2/payment/3d_Sercure.png"

import "../scss/v2/footer.scss"

function Footer() {

    const { t, i18n } = useTranslation()
    const [display, setDisplay] = useState(false)

    function CustomToggle({ children, eventKey, callback }) {
        const currentEventKey = useContext(AccordionContext);

        const decoratedOnClick = useAccordionToggle(
            eventKey,
            () => callback && callback(eventKey),
        );

        const isCurrentEventKey = currentEventKey === eventKey;

        return (
            <div onClick={decoratedOnClick}>
                {children}
                <p className="footer-link-toggle">{isCurrentEventKey ? '-' : '+'}</p>
            </div>
        );
    }


    return (
        <footer className="footer">
            <div className="container">
                <Accordion>
                    <div className="row">
                        <div className="col12 col-lg-6 text-center text-lg-left">
                            <div className="footer-logo">
                                <img className="img img-fluid footer-logo" src={LogoV2} alt={LogoV2} />
                                <span className="footer-logo-text">{t('brand.name')}</span>
                            </div>
                        </div>
                        <div className="col12 col-lg-6 text-center text-lg-right">
                            <Link to={getLink("home", i18n.language)}>
                                <button className="button orange-button">{t('footer.button.convert')}</button>
                            </Link>
                            <div className="footer-mobile-separator" />
                        </div>
                        <div className="col-12 col-lg-2">
                            <Card>
                                <Card.Header>
                                    <CustomToggle eventKey="0">
                                        <p className="footer-link-title">{t('footer.link.left.title')}</p>
                                    </CustomToggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="0">
                                    <Card.Body>
                                        <Link to={getLink("home", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.left.1')}</p>
                                        </Link>
                                        <HashLink to={getLink("home", i18n.language) + "#how-it-works"}>
                                            <p className="footer-link">{t('footer.link.left.2')}</p>
                                        </HashLink>
                                        <Link to={getLink("pricing", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.left.3')}</p>
                                        </Link>
                                        <Link to={getLink("unsubscribe", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.left.4')}</p>
                                        </Link>
                                        <Link to={getLink("gsc", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.left.5')}</p>
                                        </Link>
                                        <Link to={getLink("subscription", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.left.10')}</p>
                                        </Link>
                                        <Link to={getLink("legal", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.left.6')}</p>
                                        </Link>
                                        <Link to={getLink("cookie", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.left.7')}</p>
                                        </Link>
                                        <Link to={getLink("data", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.left.8')}</p>
                                        </Link>
                                        <Link to={getLink("warranty", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.left.9')}</p>
                                        </Link>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </div>
                        <div className="col-12 col-lg-2">
                            <Card>
                                <Card.Header>
                                    <CustomToggle eventKey="2">
                                        <p className="footer-link-title">{t('footer.link.right.title')}</p>
                                    </CustomToggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="2">
                                    <Card.Body>
                                        <Link to={getLink("unsubscribe", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.right.1')}</p>
                                        </Link>
                                        <Link to={getLink("contact", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.right.2')}</p>
                                        </Link>
                                        <Link to={getLink("login", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.right.3')}</p>
                                        </Link>
                                        <Link to={getLink("opinion", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.right.4')}</p>
                                        </Link>
                                        <Link to={getLink("home", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.right.5')}</p>
                                        </Link>
                                        <Link to={getLink("terminate", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.right.6')}</p>
                                        </Link>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </div>
                        <div className="col-12 col-lg-2 offset-lg-half first-card-container">
                            <Card>
                                <Card.Header>
                                    <CustomToggle eventKey="1">
                                        <p className="footer-link-title">{t('footer.link.middle.title')}</p>
                                    </CustomToggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="1">
                                    <Card.Body>
                                        <Link to={getLink("convertPDF", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.middle.1')}</p>
                                        </Link>
                                        <Link to={getLink("convertDOC", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.middle.2')}</p>
                                        </Link>
                                        <Link to={getLink("convertDOCX", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.middle.3')}</p>
                                        </Link>
                                        <Link to={getLink("convertTXT", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.middle.4')}</p>
                                        </Link>
                                        <Link to={getLink("convertHTML", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.middle.5')}</p>
                                        </Link>
                                        <Link to={getLink("convertXLS", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.middle.6')}</p>
                                        </Link>
                                        <Link to={getLink("convertXLSX", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.middle.7')}</p>
                                        </Link>
                                        <Link to={getLink("convertODT", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.middle.8')}</p>
                                        </Link>
                                        <Link to={getLink("convertCSV", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.middle.9')}</p>
                                        </Link>
                                        {display ?
                                            (<>
                                                <Link to={getLink("convertRAR", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middle.10')}</p>
                                                </Link>
                                                <Link to={getLink("convertZIP", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.1')}</p>
                                                </Link>
                                                <Link to={getLink("convertPPT", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.2')}</p>
                                                </Link>
                                                <Link to={getLink("convertPPTX", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.3')}</p>
                                                </Link>
                                                <Link to={getLink("convertJPEG", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.4')}</p>
                                                </Link>
                                                <Link to={getLink("convertJPG", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.5')}</p>
                                                </Link>
                                                <Link to={getLink("convertPNG", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.6')}</p>
                                                </Link>
                                                <Link to={getLink("convertGIF", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.7')}</p>
                                                </Link>
                                                <Link to={getLink("convertSVG", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.8')}</p>
                                                </Link>
                                                <Link to={getLink("convertRGB", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.9')}</p>
                                                </Link>
                                                <Link to={getLink("convertPSD", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.10')}</p>
                                                </Link>
                                                <Link to={getLink("convertIMAGE", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middle.11')}</p>
                                                </Link>
                                                <Link to={getLink("convertFONT", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middle.12')}</p>
                                                </Link>
                                                <Link to={getLink("convertTTF", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middle.13')}</p>
                                                </Link>
                                                <Link to={getLink("convertOTF", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middle.14')}</p>
                                                </Link>
                                                <Link to={getLink("convertWOFF", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middle.15')}</p>
                                                </Link>
                                            </>) : <></>
                                        }
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </div>
                        <div className="col-12 col-lg-2">
                            <Card className="no-header-mobile">
                                <Card.Header>
                                    <CustomToggle eventKey="1">
                                        <div className="footer-link-title-placeholder" />
                                    </CustomToggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="1">
                                    <Card.Body>
                                        <Link to={getLink("convertMUSIC", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.middleRight.22')}</p>
                                        </Link>
                                        <Link to={getLink("convertAAC", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.middleRight.14')}</p>
                                        </Link>
                                        <Link to={getLink("convertFLAC", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.middleRight.15')}</p>
                                        </Link>
                                        <Link to={getLink("convertMP3", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.middleRight.16')}</p>
                                        </Link>
                                        <Link to={getLink("convertWMA", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.middleRight.17')}</p>
                                        </Link>
                                        <Link to={getLink("convertM4A", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.middleRight.18')}</p>
                                        </Link>
                                        <Link to={getLink("convertOGG", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.middleRight.19')}</p>
                                        </Link>
                                        <Link to={getLink("convertAMR", i18n.language)}>
                                            <p className="footer-link">{t('footer.link.middleRight.20')}</p>
                                        </Link>
                                        {display ?
                                            (<>
                                                <Link to={getLink("convertWAV", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.21')}</p>
                                                </Link>
                                                <Link to={getLink("convertVIDEO", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.13')}</p>
                                                </Link>
                                                <Link to={getLink("convertAVI", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.23')}</p>
                                                </Link>
                                                <Link to={getLink("convertFLV", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.24')}</p>
                                                </Link>
                                                <Link to={getLink("convertMKV", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.25')}</p>
                                                </Link>
                                                <Link to={getLink("convertMPEG", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.26')}</p>
                                                </Link>
                                                <Link to={getLink("convertRMVB", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.27')}</p>
                                                </Link>
                                                <Link to={getLink("convertMOV", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.28')}</p>
                                                </Link>
                                                <Link to={getLink("convertMP4", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.29')}</p>
                                                </Link>
                                                <Link to={getLink("convertEBOOK", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.33')}</p>
                                                </Link>
                                                <Link to={getLink("convertMOBI", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.34')}</p>
                                                </Link>
                                                <Link to={getLink("convertEPUB", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.35')}</p>
                                                </Link>
                                                <Link to={getLink("compress", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.left.10')}</p>
                                                </Link>
                                                <Link to={getLink("compressimage", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.11')}</p>
                                                </Link>
                                                <Link to={getLink("compressPDF", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.middleRight.12')}</p>
                                                </Link>
                                                <Link to={getLink("splitPdf", i18n.language)}>
                                                    <p className="footer-link">{t('footer.link.left.11')}</p>
                                                </Link>

                                            </>) : <p className="footer-link" onClick={() => { setDisplay(true) }} >{t('footer.link.left.more')}</p>
                                        }
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </div>
                        <div className="col-12 col-lg-3">
                            <div className="footer-mobile-separator" />
                            <p className="footer-link-title footer-contact-link-title">{t('footer.link.contact.title')}</p>
                            <div className="container p-0">
                                <a className="footer-social-link" href={`tel:${t('footer.link.contact.phone.number')}`} target="_blank" rel="noopener noreferrer">
                                    <div className="row">
                                        <div className="col-3 footer-contact-data-container">
                                            <div className="footer-icon-container no-border">
                                                <FontAwesomeIcon icon={faPhone} />
                                            </div>
                                        </div>
                                        <div className="col-9 footer-contact-data-container">
                                            <div className="footer-phone-container">
                                                <p className="footer-phone-number">{t('footer.link.contact.phone.number')}</p>
                                            </div>
                                            <p className="footer-small-info">{t('footer.link.contact.phone.info')}</p>
                                        </div>
                                    </div>
                                </a>
                                <a className="footer-social-link" href={`mailto:${t('footer.link.contact.email.email')}`} target="_blank" rel="noopener noreferrer">
                                    <div className="row">
                                        <div className="col-3 footer-social-link-container">
                                            <div className="footer-icon-container no-border">
                                                <FontAwesomeIcon icon={faEnvelope} />
                                            </div>
                                        </div>
                                        <div className="col-9 footer-contact-data-container">
                                            <p className="footer-email">{t('footer.link.contact.email.email')}</p>
                                            <p className="footer-small-info">{t('footer.link.contact.email.info')}</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-12 footer-separator" />
                        <div className="col-12 col-lg-6 offset-lg-3 footer-small-info-container">
                            <img className="img-fluid footer-small-info-container-secure secure-3d" src={secureMethod2} alt='Secure payment Visa and Mastercard' />
                            <img className="img-fluid footer-small-info-container-secure" src={secureMethod} alt='Secure payment' />
                            <div className="footer-mobile-separator" />
                            <p className="footer-small-info">{t('footer.small.info', { year: new Date().getFullYear() })}</p>
                        </div>
                    </div>
                </Accordion>
            </div>
        </footer>
    )
}

export default Footer;
